<template>
    <el-dialog :visible="visible" :modal-append-to-body="false" class="vendor-detail-dialog ah-detail-dialog" :before-close="handleBeforeClose" ref="DetailDialog">
        <template slot="title">
            <el-row>
                <el-col :span="16">
                    客戶 <span class="sno"># {{ this.vendor.voo }}</span>
                </el-col>
                <el-col :span="8">
                    <!-- <el-button size="small">列印</el-button> -->
                </el-col>
            </el-row>
        </template>
        <div class="detail-row header">
            <el-row :gutter="40">
                <el-col :sm="14">
                    <div class="detail-block" style="margin-bottom: 5px">
                        <div style="margin: 15px 0 0px 0">
                            <div style="font-size: 15pt; font-weight: bold; margin-top: 5px">
                                {{ vendor.fnam }}
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="detail-row">
            <div class="detail-block">
                <el-row :gutter="40">
                    <el-col :sm="14">
                        <table class="ah-basic-data-table">
                            <tbody>
                                <tr>
                                    <th>統一編號</th>
                                    <td>
                                        <span v-if="vendor.bsn != ''">{{ vendor.bsn }}</span>
                                        <span v-if="vendor.bsn == ''" class="none-txt">(無)</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>聯絡地址</th>
                                    <td>
                                        <span v-if="vendor.adr != ''">{{ vendor.adr }}</span>
                                        <span v-if="vendor.adr == ''" class="none-txt">(無)</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>匯款帳號後五碼</th>
                                    <td>
                                        <span v-if="vendor.accountLast5Number && vendor.accountLast5Number !== ''">{{ vendor.accountLast5Number }}</span>
                                        <span v-else class="none-txt">(無)</span>
                                    </td>
                                </tr>
                                <tr v-if="vendor.bilL_DAY != 0">
                                    <th>結帳日</th>
                                    <td>{{ vendor.bilL_DAY }} 日</td>
                                </tr>
                                <tr v-if="vendor.soO_DAY != 0">
                                    <th>付款日</th>
                                    <td>{{ vendor.soO_DAY }} 日</td>
                                </tr>
                                <tr>
                                    <th>備註</th>
                                    <td>
                                        <div style="white-space: pre">
                                            {{ vendor.note }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </el-col>
                    <el-col :sm="10">
                        <table class="ah-basic-data-table">
                            <tbody>
                                <tr>
                                    <th>資料建立人</th>
                                    <td>{{ vendor.crT_USR }}</td>
                                </tr>
                                <tr>
                                    <th>建立時間</th>
                                    <td>
                                        {{ vendor.crT_DAT | dateFormater("YYYY-MM-dd") }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-tabs class="detail-tabs" v-model="currTab" v-if="vendor">
            <el-tab-pane name="projects">
                <template slot="label"> 專案 ({{ vendor.projects.length }}) </template>
            </el-tab-pane>
            <el-tab-pane name="contacts">
                <template slot="label"> 聯絡窗口 ({{ vendor.vendorContacts.length }}) </template>
            </el-tab-pane>
        </el-tabs>
        <div class="detail-row" v-if="currTab == 'projects'">
            <div class="detail-block">
                <el-table class="ah-el-data-table" :data="vendor.projects" empty-text="沒有專案" size="mini" :key="'projects'">
                    <el-table-column type="index" width="40"> </el-table-column>
                    <el-table-column prop="poo" label="單號" width="120">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleProjectClick(scope.row.sno)">{{ scope.row.poo }}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="nam" label="專案名稱" :show-overflow-tooltip="true"> </el-table-column>
                    <el-table-column prop="stF_NAM" label="專案經理" width="100" :show-overflow-tooltip="true"> </el-table-column>
                    <el-table-column prop="amt" label="金額" align="right" width="150">
                        <template slot-scope="scope">
                            <Money :v="scope.row.amt" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="cny" label="幣別" width="100"></el-table-column>
                </el-table>
            </div>
        </div>
        <div class="detail-row" v-if="currTab == 'contacts'">
            <div class="detail-block">
                <el-row :gutter="30">
                    <el-col :sm="vendor.vendorContacts.length == 1 ? 24 : 12" v-for="contact in vendor.vendorContacts" :key="contact.sno" class="contact">
                        <el-card class="contact-card" shadow="never">
                            <table class="ah-basic-data-table">
                                <tbody>
                                    <tr>
                                        <th>姓名</th>
                                        <td>
                                            {{ contact.nam }}
                                            <span style="font-size: 9pt; font-weight: normal; margin-left: 10px">{{ contact.gen == 0 ? "先生" : "小姐" }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>職稱</th>
                                        <td>
                                            <span v-if="contact.job">{{ contact.job }}</span>
                                            <span v-else class="none-txt">(無)</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>聯絡電話</th>
                                        <td>
                                            <span v-if="contact.tel">
                                                {{ contact.tel }}
                                                <span v-if="contact.ext != ''"># {{ contact.ext }}</span>
                                            </span>
                                            <span v-else class="none-txt">(無)</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Email</th>
                                        <td>
                                            <span v-if="contact.eml">{{ contact.eml }} </span>
                                            <span v-else class="none-txt">(無)</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="detail-row footer right">
            <el-tooltip class="item" effect="dark" content="此客戶已有專案，無法刪除" placement="top-start" v-if="vendor.projects.length > 0 && !isQR()">
                <el-button type="">刪除</el-button>
            </el-tooltip>
            <el-button type="" @click="handleDeletBtnClick" v-if="vendor.projects.length == 0 && !isQR()">刪除</el-button>
            <el-button type="dark" @click="handleEditBtnClick" v-if="!isQR()">編輯</el-button>
        </div>
        <ProjectDetailDialog ref="projectDetailDialog" :visible="detailDialogVisible" @close="handleDetailDialogClose" :sno="detailDialogSno" />
    </el-dialog>
</template>
<script>
import ProjectDetailDialog from '@/components/dashboard/Project/ProjectDetailDialog.vue';

export default {
    name: 'vender-detail',
    props: ['visible', 'sno'],
    components: { ProjectDetailDialog },
    data() {
        return {
            shownContactSno: '',
            currTab: 'contacts',
            status: '',
            detailDialogVisible: false,
            detailDialogSno: null,
            vendor: {
                sno: 0,
                mno: 0,
                vdR_TYP: '',
                voo: '',
                cnam: '',
                fnam: '',
                bsn: '',
                bsN_NO: 0,
                cty: '',
                ara: '',
                adR_CODE: '',
                adr: '',
                abd: 0,
                onf: 0,
                bilL_DAY: 0,
                soO_DAY: 0,
                crT_DAT: '',
                crT_USR: '',
                crT_UNO: 0,
                upD_DAT: '',
                upD_USR: '',
                upD_UNO: 0,
                filE_AGREE: '',
                projects: [],
                vendorContacts: [
                    {
                        sno: 0,
                        mno: 0,
                        fsno: 0,
                        nam: '',
                        job: '',
                        dep: '',
                        gen: 0,
                        tel: '',
                        ext: '',
                        eml: '',
                        onf: 0,
                        crT_DAT: '',
                        crT_USR: '',
                        crT_UNO: 0,
                        upD_DAT: '',
                        upD_USR: '',
                        upD_UNO: 0,
                    },
                ],
            },
        };
    },
    watch: {
        sno(newSno) {
            if (newSno) {
                this.fetchData(newSno);
            }
        },
    },
    mounted() {},
    methods: {
        fetchData(sno) {
            this.status = 'loading';

            const loadingTarget = this.$refs.DetailDialog.$el.querySelector('.el-dialog');
            const loading = this.$loading({
                lock: true,
                text: '載入中',
                spinner: 'el-icon-loading',
                target: loadingTarget,
            });

            this.$api({
                url: `VendorManagementPage/GetVendorInfo?SNO=${sno}`,
                data: null,
                method: 'GET',
            })
                .then((resp) => {
                    console.log('Vendor', resp.data);

                    // 變更狀態
                    this.status = 'success';

                    // 變更詳細資料
                    this.vendor = resp.data.item;

                    // 如果只有一個聯絡窗口，則直接打開顯示
                    if (this.vendor.vendorContacts.length === 1) {
                        this.shownContactSno = this.vendor.vendorContacts[0].sno;
                    }
                })
                .finally(() => {
                    loading.close();
                });
        },
        handleBeforeClose() {
            this.$emit('close');
        },
        handleEditBtnClick() {
            this.$router.push({
                name: 'vendor-edit',
                params: { sno: this.vendor.sno },
            });
        },
        handleDeletBtnClick() {
            this.$confirm('確認要刪除此客戶？', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            })
                .then(() => {
                    this.submitDelete();
                })
                .catch(() => {});
        },
        handleProjectClick(sno) {
            this.detailDialogVisible = true;
            this.detailDialogSno = sno;
        },
        handleDetailDialogClose(refresh) {
            this.detailDialogVisible = false;
            this.detailDialogSno = null;
            this.$emit('detailClose', refresh);
        },
        submitDelete() {
            this.$api({
                method: 'DELETE',
                url: '/VendorManagementPage/DeleteVendor',
                data: { sno: this.vendor.sno },
            }).then(() => {
                this.$emit('close', true);
            });
        },
        applyContactsKey(vendorData) {
            for (let i = 0; i < vendorData.vendorContacts.length; i += 1) {
                // eslint-disable-next-line no-param-reassign
                vendorData.vendorContacts[i].key = i;
            }
            return vendorData;
        },
        formatDatetime(time) {
            const t = new Date(time);
            return `${t.getUTCFullYear()}/${t.getUTCMonth() + 1}/${t.getUTCDate()}`;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.vendor-detail-dialog {
    .contact-card {
    }
}
</style>
